<template>
    <div class="window-wrapper window-no-save-contacts">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Ваши данные не сохранятся. Продолжить?</div>
                    <div class="button-block">
                        <button @click="confirm" class="button button-dark button-close-window">Да</button>
                        <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ContactNoSaveWindow",

        methods: {
            confirm() {
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
                this.$emit('confirmNext');

            },
            closeWindow() {
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            }
        }
    }
</script>

<style scoped>

</style>